export default {"src":"/_next/static/media/file-copy-line.1ae8e7c9.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};